import { Box, Card, CardContent, Tab, Tabs, Typography } from "@mui/material";
import React, { useState } from "react";
import AdminDashboardLayout from "../../../layouts/admin_dashboard_layout/admin_dashboard_layout";
import UploadDexcoMemberTab from "./upload_dexco_member_tab";
import ManageDexcoMembersTab from "./manage_dexco_members_tab";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`dexco-tabpanel-${index}`}
      aria-labelledby={`dexco-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

export default function DexcoAdminPage() {
  const [currentTab, setCurrentTab] = useState(0);

  return (
    <AdminDashboardLayout>
      <Box flex={1} mt={2} mx={2}>
        <Card sx={{ borderRadius: 1, m: 3 }} elevation={1}>
          <CardContent>
            <Typography variant="h5" fontWeight="600" mb={2}>
              DEXCO Management
            </Typography>

            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs
                value={currentTab}
                onChange={(_, newValue) => setCurrentTab(newValue)}
                aria-label="dexco management tabs"
                variant="scrollable"
                scrollButtons="auto"
              >
                <Tab label="Add Member" id="dexco-tab-0" />
                <Tab label="Manage Members" id="dexco-tab-1" />
              </Tabs>
            </Box>

            <TabPanel value={currentTab} index={0}>
              <UploadDexcoMemberTab onSuccess={() => setCurrentTab(1)} />
            </TabPanel>

            <TabPanel value={currentTab} index={1}>
              <ManageDexcoMembersTab />
            </TabPanel>
          </CardContent>
        </Card>
      </Box>
    </AdminDashboardLayout>
  );
}
